import jwtDecode from "jwt-decode";
import { Queuetype } from "../containers/ccsmodule/queues/settings/componenets/queueType";
import { post, get, put, remove } from "./api.service.v2";
import { APIResponse } from "./interfaces";
import { useKeycloak } from "@react-keycloak/web";
import { useSelector } from "react-redux";
import { RootState } from "../store";

const fetchTenantId = () => {
  const currentAccount: any = window.localStorage.getItem("currentAccount");
  let value = JSON.parse(currentAccount);
  console.log("fetchTenantId", value);
  return value;
};


// export function useToken() {
//   console.log("ACCESSKEY", localStorage?.getItem("ACCESSKEY"))
//   const tokenn = localStorage?.getItem("ACCESSKEY")
//   return tokenn;
// }

export async function getQueues(search?: string): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues?search=${search ?? ""}` : `srv/ccs/queues?search=${search ?? ""}`}`;
  return get(endpoint, { source: "default", skipTelco: true });
}

export async function getAgentsInQueue(agentId?: string): Promise<APIResponse> {
  const endpoint = agentId ? `srv/ccs/queues/agent/${agentId}` : `srv/ccs/queues/agent`;
  return get(endpoint, { source: "default", skipTelco: true });
}

export async function getAgents(
  queueId: string,
  limit: number,
  start: number,
  search?: string
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}/agent?limit=${limit}&start=${start}&search=${search ?? ""}`
    : `srv/ccs/queues/${queueId}/agent?limit=${limit}&start=${start}&search=${search ?? ""}`
    }`;

  return get(endpoint, { source: "default", skipTelco: true });
}

export async function resetPassword(emailInfo: string): Promise<APIResponse> {

  const endpoint = `reset_password`;

  return post(endpoint, emailInfo, { skipTelco: true, source: "default" });

}

export async function getSupervisors(
  queueId: string,
  limit: number,
  start: number,
  search?: string
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}/supervisor?limit=${limit}&start=${start}&search=${search ?? ""}`
    : `srv/ccs/queues/${queueId}/supervisor?limit=${limit}&start=${start}&search=${search ?? ""}`
    }`;

  return get(endpoint, { source: "default", skipTelco: true });
}

export async function updateQueueSettings(
  queueId: string,
  payload: Queuetype
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}`
    : `srv/ccs/queues/${queueId} `
    }`;

  return put(endpoint, payload, { source: "default", skipTelco: true });
}

export async function removeAgent(
  agentId: string,
  queueId: string
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}/agent/${agentId}`
    : `srv/ccs/queues/${queueId}/agent/${agentId}`
    }`;

  return remove(endpoint, {}, { source: "default", skipTelco: true });
}

export async function removeSupervisor(
  supervisorId: string,
  queueId: string
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}/supervisor/${supervisorId}`
    : `srv/ccs/queues/${queueId}/supervisor/${supervisorId}`
    }`;

  return remove(endpoint, {}, { source: "default", skipTelco: true });
}

export async function addNewSupervisor(
  queueId: string,
  payload: { supervisor: { user_id: string }[] }
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}/supervisor`
    : `srv/ccs/queues/${queueId}/supervisor`
    }`;

  return post(endpoint, payload, { source: "default", skipTelco: true });
}

export async function getAvailableSupervisors(
  queueId: string,
  limit: number,
  start: number,
  search?: string
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}/supervisor?limit=${limit}&start=${start}&search=${search ?? ""}&flag=Available_users`
    : `srv/ccs/queues/${queueId}/supervisor?limit=${limit}&start=${start}&search=${search ?? ""}&flag=Available_users`
    }`;

  return get(endpoint, { source: "default", skipTelco: true });
}

export async function addNewAgents(
  queueId: string,
  payload: { agent: { priority: number | null; user_id: string }[] }
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}/agent`
    : `srv/ccs/queues/${queueId}/agent`
    }`;

  return post(endpoint, payload, { source: "default", skipTelco: true });
}

export async function getAvailableAgents(
  queueId: string,
  limit: number,
  start: number,
  search?: string
): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}/agent?limit=${limit}&start=${start}&search=${search ?? ""}&flag=Available_users`
    : `srv/ccs/queues/${queueId}/agent?limit=${limit}&start=${start}&search=${search ?? ""}&flag=Available_users`
    }`;

  return get(endpoint, { source: "default", skipTelco: true });
}

export async function addQueue(payload: {
  name: string;
}): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues`
    : `srv/ccs/queues`
    }`;

  return post(endpoint, payload, { source: "default", skipTelco: true });
}

export async function removeQueue(queueId: string): Promise<APIResponse> {
  const isSuperTelco = fetchTenantId()?.account_type ? null : fetchTenantId();

  const endpoint = `${isSuperTelco
    ? `srv/ccs/tenants/${isSuperTelco?.uuid}/queues/${queueId}`
    : `srv/ccs/queues/${queueId}`
    }`;

  return remove(endpoint, {}, { source: "default", skipTelco: true });
}

export async function getReports(args: {
  id: string;
  date: { start: number; end: number };
  queueId: string;
  timeInterval: string;
  state: string;
  filter: string;
  agent?: boolean;
}): Promise<APIResponse> {
  const { id, date, queueId, timeInterval, state, filter, agent } = args;
  console.log("insideapi");
  let endpoint = `srv/ccs/${agent ? "agent" : "supervisor"}/${id}/reports?report_type=perf_report&queue_ids=${queueId}&from_date=${date?.start}&offset=${new Date().getTimezoneOffset() * 60000}&to_date=${date?.end}&period_type=${timeInterval}&state=${state}&filter=${filter === "time" ? state.split(",")[0] : filter}`;

  return get(endpoint, { source: "default", skipTelco: true });
}

export async function getAvgWaitReport(args: {
  id: string;
  date: { start: number; end: number };
  queueId: string;
  timeInterval: string;
  agent?: boolean;
}): Promise<APIResponse> {
  const { id, date, queueId, agent, timeInterval } = args;

  let endpoint = `srv/ccs/${agent ? "agent" : "supervisor"}/${id}/reports?report_type=avgwt_time&queue_ids=${queueId}&from_date=${date?.start}&offset=${(new Date().getTimezoneOffset() * 60)}&to_date=${date?.end}&period_type=${timeInterval}`;
  return get(endpoint, { source: "default", skipTelco: true });
}




export async function getCallBackSummaryReport(
  args: {
    id: string;
    date: { start: number; end: number };
    timeInterval: string;
    queueId: string;
    state: string;
    agent?: boolean;
  }
): Promise<APIResponse> {
  const { id, date, queueId, agent, timeInterval, state } = args;

  let endpoint = `srv/ccs/${agent ? "agent" : "supervisor"}/${id}/reports?report_type=callback&queue_ids=${queueId}&from_date=${date?.start}&offset=${(new Date().getTimezoneOffset() * 60)}&to_date=${date?.end}&period_type=${timeInterval}&state=${state}`;
  return get(endpoint, { source: "default", skipTelco: true });
}


export async function getSlaReport(args: {
  id: string;
  date: { start: number; end: number };
  timeInterval: string;
  queueId: string;
  agent?: boolean;


}): Promise<APIResponse> {
  const { id, date, queueId, agent, timeInterval, } = args;

  let endpoint = `srv/ccs/${agent ? "agent" : "supervisor"}/${id}/reports?report_type=sla&queue_ids=${queueId}&from_date=${date?.start}&offset=${(new Date().getTimezoneOffset() * 60)}&to_date=${date?.end}&period_type=${timeInterval}`;
  return get(endpoint, { source: "default", skipTelco: true });
}


export async function getAllAgentsInTenant(args: {
  tenantId: string;
}): Promise<APIResponse> {
  const { tenantId, } = args;

  let endpoint = `srv/ccs/tenants/${tenantId}/queues/agent`
  return get(endpoint, { source: "default", skipTelco: true });
}



export async function getAgentCallSummaryReport(args: {
  queueId: string,
  agentId: string
  timeInterval: string
  state: string
  id: string
  date: { start: number; end: number };
}): Promise<APIResponse> {
  const { queueId, agentId, date, timeInterval, state, id } = args;


  let endpoint = `srv/ccs/supervisor/${id}/reports?report_type=agent_summary_report&queue_ids=${queueId}&agent_ids=${agentId}&state=${state}&from_date=${date?.start}&offset=${(new Date().getTimezoneOffset() * 60)}&to_date=${date?.end}&period_type=${timeInterval}`

  return get(endpoint, { source: "default", skipTelco: true })
}



export async function getAgentPerfReport(args: {
  queueId: string,
  agentId: string
  timeInterval: string
  state: string
  id: string
  date: { start: number; end: number };
}): Promise<APIResponse> {
  const { queueId, agentId, date, timeInterval, state, id } = args;


  let endpoint = `srv/ccs/supervisor/${id}/reports?report_type=agent_perf_report&queue_ids=${queueId}&agent_ids=${agentId}&state=${state}&from_date=${date?.start}&offset=${(new Date().getTimezoneOffset() * 60)}&to_date=${date?.end}&period_type=${timeInterval}`

  return get(endpoint, { source: "default", skipTelco: true })
}


export async function getAgentMissedCallReport(args: {
  queueId: string,
  agentId: string
  timeInterval: string
  state: string
  id: string
  date: { start: number; end: number };
}): Promise<APIResponse> {
  const { queueId, agentId, date, timeInterval, state, id } = args;


  let endpoint = `srv/ccs/supervisor/${id}/reports?report_type=agent_missedcall_activity&queue_ids=${queueId}&agent_ids=${agentId}&state=${state}&from_date=${date?.start}&offset=${(new Date().getTimezoneOffset() * 60)}&to_date=${date?.end}&period_type=${timeInterval}`

  return get(endpoint, { source: "default", skipTelco: true })
}

export async function getAgentMissedRate(args: {
  queueId: string,
  agentId: string
  id: string
  date: { start: number; end: number };
}): Promise<APIResponse> {
  const { queueId, agentId, date, id } = args;


  let endpoint = `srv/ccs/supervisor/${id}/reports?report_type=agent_missed_rate&queue_ids=${queueId}&agent_ids=${agentId}&from_date=${date?.start}&offset=${(new Date().getTimezoneOffset() * 60)}&to_date=${date?.end}`

  return get(endpoint, { source: "default", skipTelco: true })
}
